/* eslint-disable no-secrets/no-secrets */
import React, { useEffect, useCallback, useContext, useState } from 'react';
import appConfig from 'app-config';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLAgentQuoteStickyComponent, MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLAgentQuoteStickyAutoComponent } from 'gw-capability-gateway-quoteandbind-pa-react';
import { MLUWService } from 'gw-capability-gateway';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import { MLNavigationStepsTrackingService, MLPolicyChangeDataHolderService } from 'ml-services-common-react';
import { MLEndorsementUtil, MLEndorsementFlowUtil,MLProductCodeUtil  } from 'ml-portals-util-js';
import { platformMessages } from 'ml-components-platform-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';

import {
    MLOutOfSequenceConflictComponent,
    MLHOEditCoveragesComponent,
    MLPUPEditCoveragesComponent,
    MLPAAgentEditCoveragesComponent
} from 'ml-components-common-react';


import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import metadata from './MLCoveragesPage.metadata.json5';
import styles from './MLCoveragesPage.module.scss';
import messages from './MLCoveragesPage.messages';

import { IntlContext } from '@jutro/legacy/locale';

const EMPTY_STRING = 'Empty';
const ITVERRORMESSAGE = 'ITVError';
const RATING_ERROR = 'RatingError';
const defensiveDriverCodes = ['PADefensiveDriver_ML'];
const accidentPreventionCodes = ['PADriversRoleModiferPreventionCourse_ML', 'PADriverAccidentPrevention_ML'];
const FUNCTIONAL_REPLACEMENT_COST_TERM_VALUE = 'Functional Replacement Cost';
const DEFAULT_TERM_MONTHS = 12;
const HALF_TERM_MONTHS = 6;
const VALIDATION_ALERT_NAME = 'validationErrorAlert';
const TERM_TYPE_HALF_YEAR = 'HalfYear';
const TERM_TYPE_7_DAY = '7Days';
const THIRD_PARTY_ALERT_NAME = 'thirdPartyAlert';

const excludedCoveragesWithDependencies = [
    'HOPPrivateStructureExclusion_ML',
    'HOPOffPremisesTheftExclusion',
    'HOPWindstormOrHailCoverageExclusion',
    'HOPMasonryVeneerExclusion_ML',
    'GenericHOPEarthquakeMasonryExclType'
];

// Gateway ml-coverages.html, MLCoveragesCtrl.js
function MLCoveragesPage(props) {
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        changeNextSteps,
        currentStep,
        jumpTo
    } = props;

    const { MLUWIssuesBlockingPoints } = appConfig;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const { authHeader } = useAuthentication();
    const intl = useContext(IntlContext);

    const {
        getVehicleDiscountMessage,
        isVehicleEligibleForAccidentPrevention,
        getRatedDriversNonStudent,
        validateVehiclesHaveAssignmentsForEveryDriver,
        validateVehicleAssignmentPercentages
    } = MLDriverVehicleUtil();

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        getNumberOfAlerts,
        clearAlerts
    } = MLNotificationBlockUtil();

    const { submissionVM: endorsementVM } = wizardData;
    const isOOSConflict = _.get(endorsementVM, 'isOutOfSequenceConflict_ML.value');
    const vehicles = _.get(endorsementVM, 'lobData.personalAuto.coverables.vehicles.value', []);
    const vehicleDrivers = _.get(endorsementVM, 'lobData.personalAuto.coverables.vehicleDrivers_Ext', []);
    const jobID = _.get(endorsementVM, 'jobID.value');
    const uwIssues = _.get(endorsementVM, 'uwIssues_ML.value');
    const lobPathString = _.camelCase(_.get(endorsementVM, 'baseData.productName.value', ''));
    const paDrivers = _.get(endorsementVM, 'lobData.personalAuto.coverables.drivers.value')
    const ratedDrivers = paDrivers ? paDrivers.filter((driver) => driver.type_ML === 'rated') : undefined;
    const hoCoveragePartType = _.get(endorsementVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
    const productCode = _.get(endorsementVM, 'baseData.productCode.value', '');

      const coveragePartType = endorsementVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code;

    const isModernProduct = _.get(endorsementVM, 'isModernProduct_Ext.value', false)

    const isNotDwellingPolicy = !(MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType))

    const isLLPolicy = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(coveragePartType) || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(coveragePartType) 
    
    
    const isEligibleModernHomeowners = _.get(endorsementVM, 'isModernProduct_Ext.value', false) &&
        MLProductCodeUtil.isHomeOwners(endorsementVM.baseData.productCode.value) &&
        (
            MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType) ||
            MLProductCodeUtil.isHomeOwnersPartialTypeCondo(coveragePartType)
        );

    const occupancyType = endorsementVM?.lobData?.homeowners?.preQualQuestionSets?.value?.[0]?.answers?.HOPPreQualHomeCondoDwellingOccupancy_Ext
    const isOccupancySecondaryOrSeasonal = isEligibleModernHomeowners && ['HOPPreQualHomeCondoOccupancySecondary', 'HOPPreQualHomeCondoOccupancySeasonal'].includes(occupancyType);

    const isAgent = appConfig.agentendorsement === 'true';
    const isGPA = appConfig.portalCode === 'GPA';

    const paModel = endorsementVM.lobData.personalAuto.value;
    const hasNamedNonOwner = paModel && paModel.hasNamedNonOwner();
    const isPersonalAuto = endorsementVM.value.isPersonalAuto();
    const isHomeOwners = endorsementVM.value.isHomeOwners()

    const [maxNumberVehicleShown, setMaxNumberOfVehicleShown] = useState(undefined);
    const [prevIndex, setPrevIndex] = useState(undefined);
    const [nextIndex, setNextIndex] = useState(undefined);
    const [isPrevAvailable, setIsPrevAvailable] = useState(undefined);
    const [isNextAvailable, setIsNextAvailable] = useState(undefined);
    const [lineCoverageNamesMap, setLineCoverageNamesMap] = useState([]);
    const [vehicleCoverageNamesMap, setVehicleCoverageNamesMap] = useState([]);
    const [optionalCoverageNamesMap, setOptionalCoverageNamesMap] = useState([]);
    const [coverablesToDisplay, setCoverablesToDisplay] = useState([]);
    const [termMonths, setTermMonths] = useState(undefined);
    const [termType_ML, setTermType_ML] = useState(undefined);
    const [isBlockedByUWIssues, setIsBlockedByUWIssues] = useState(undefined);
    const [wasCoverageChanged, setWasCoverageChanged] = useState(undefined);
    const [primaryVehiclesDefaulted, setPrimaryVehiclesDefaulted] = useState(false);
    const [defaultedDriverPrimaryVehicles] = useState([]);
    const [primaryDriversDefaulted, setPrimaryDriversDefaulted] = useState(false);
    const [disableContinueForValidationErrors, setDisableContinueForValidationErrors] = useState(false);
    const [vehicleDriversRestored, setVehicleDriversRestored] = useState(false);
    const [primaryVehiclesRestored, setPrimaryVehiclesRestored] = useState(false);

    const getQuoteCoverages = useCallback(() => {
        const offerings = _.get(endorsementVM, `lobData.${lobPathString}.offerings.value`, []);
        const selectedOffering = offerings[0];
        return _.get(selectedOffering, 'coverages');
    }, [endorsementVM, lobPathString]);

    const [covsModel, setCovsModel] = useState(getQuoteCoverages());
    const [covPagePerfFixEnabled, setCovPagePerfFixEnabled] = useState(false);

    const COVERAGE_ERROR_MESSAGES = [
        'Remove Limited Matching'
    ];

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const getPerTermLabel = useCallback((selectedTermType) => {
        let label = translator(messages.perTermLabelYear);
        if (selectedTermType === TERM_TYPE_HALF_YEAR) {
            label = translator(messages.perTermLabel6Month);
        } else if (selectedTermType === TERM_TYPE_7_DAY) {
            label = translator(messages.perTermLabel7day);
        }
        return label;
    }, [translator]);

    const getPolicyChangeCoverages = useCallback((policyChange) => {
        const offerings = _.get(policyChange, `lobData.${lobPathString}.offerings`, []);
        const selectedOffering = offerings[0];
        return _.get(selectedOffering, 'coverages');
    }, [lobPathString]);

    const getQuoteCoveragesVM = useCallback((quote) => {
        const offeringsVM = _.get(endorsementVM, `lobData.${lobPathString}.offerings.children`, []);
        const selectedOffering = quote ? offeringsVM.find((o) => o.branchCode.value === quote.branchCode && o.branchName.value === quote.branchName) : offeringsVM[0];
        return _.get(selectedOffering, 'coverages');
    }, [endorsementVM, lobPathString]);

    // TODO : TA105643 : remove when PC rules are implemented
    const validatePANamedExclude = useCallback((callback) => {
        if (!isPersonalAuto) {
            return callback(true);
        }
        const currentCoverages = getQuoteCoverages();
        const vehicleCoverages = _.get(currentCoverages, 'vehicleCoverages');
        // named non owner / no vehicle
        if (!vehicleCoverages) {
            return callback(true);
        }

        let isValid = true;
        vehicleCoverages.forEach((vehCov) => {
            const alertName = `paNamedExclude${vehCov.fixedId}`;
            clearBlockAlerts(alertName);
            const paNamedExcludeAllSelectedMessage = {...messages.paNamedExcludeAllSelectedMessage, args: { vehicleName: vehCov.vehicleName }};
            const paNamedExcludeNoneSelectedMessage = {...messages.paNamedExcludeNoneSelectedMessage, args: { vehicleName: vehCov.vehicleName }};
            const selectedNamedExcludeCov = vehCov.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML' && cov.selected);
            if (selectedNamedExcludeCov) {
                const drivers = selectedNamedExcludeCov.scheduledItems_ML.excludeNamedDrivers;
                const driversSelected = drivers.filter((d) => d.driverExcluded);
                if (driversSelected.length === 0) {
                    addErrorAlert(paNamedExcludeNoneSelectedMessage, alertName);
                    isValid = false;
                }
                if (driversSelected.length === drivers.length) {
                    addErrorAlert(paNamedExcludeAllSelectedMessage, alertName);
                    isValid = false;
                }
            }
        });
        return callback(isValid);

    }, [addErrorAlert, clearBlockAlerts, getQuoteCoverages, isPersonalAuto]);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Reached', false, endorsementVM, authHeader, { step: 'PolChange Coverage Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isSuspendLiabilitySelected = useCallback(() => {
        const alertName = 'suspendLiabilitySelected';
        let warningDisplayed = false;
        clearBlockAlerts(alertName);
        if (isPersonalAuto) {
            const currentCoverages = getQuoteCoverages();
            currentCoverages.vehicleCoverages.forEach((vehicleCoverage) => {
                vehicleCoverage.coverages.forEach((coverage) => {
                    if (coverage.name === 'Suspend Liability' && coverage.selected === true) {
                        setWasCoverageChanged(true);
                        if (!warningDisplayed) {
                            addWarningAlert(messages.suspendedLiability, alertName);
                            window.scrollTo(0, 0);
                            warningDisplayed = true;
                        }
                    }
                });
            });
        }
    }, [addWarningAlert, clearBlockAlerts, getQuoteCoverages, isPersonalAuto]);

    const isFortifiedUnselected = useCallback(() => {
        if(!isHomeOwners || !isModernProduct) return;
        clearBlockAlerts('fortifiedRoofWarning');
        const showWarning = _.get(endorsementVM, 'lobData.homeowners.shoudlShowFortifiedWarning.value', false)
        if (showWarning) {
            addWarningAlert(messages.fortifiedRoofWarning, 'fortifiedRoofWarning');
            window.scrollTo(0, 0);
        }
    },[clearBlockAlerts, isHomeOwners, endorsementVM, isModernProduct])

    const isDwelling = useCallback(() => {
        return endorsementVM.value.isDwelling();
    }, [endorsementVM]);

    const isLandlordHome = useCallback(() => {
        return endorsementVM.value.isLandlordHome();
    }, [endorsementVM]);

    const shouldTestFunctionalReplacementCost = (details) => {
        return details && details.yearBuilt < 1986 && details.isReplacementCostSelected_ML !== undefined;
    };

    const updateFunctionalReplacementCostWarning = useCallback(() => {
        let showWarning = false;

        const constructionDetails = _.get(endorsementVM, 'lobData.homeowners.coverables.constructionDetails_ML.value');
        if ((isDwelling() || isLandlordHome()) && shouldTestFunctionalReplacementCost(constructionDetails)) {
            clearBlockAlerts(FUNCTIONAL_REPLACEMENT_COST_TERM_VALUE);
            const isDwellingReplacementCostSelected = constructionDetails.isReplacementCostSelected_ML;
            let isCoverageFunctionalReplacementCostSelected = false;

            const currentCoverages = getQuoteCoverages();
            if (currentCoverages) {
                currentCoverages.baseCoverages.forEach((basecoverage) => {
                    if (basecoverage.code_ML === 'HOPCovA') {
                        basecoverage.terms.forEach((hopcovaterm) => {
                            if ((hopcovaterm.codeIdentifier_ML === 'HOPCovAValuation') && (hopcovaterm.chosenTermValue === FUNCTIONAL_REPLACEMENT_COST_TERM_VALUE)) {
                                isCoverageFunctionalReplacementCostSelected = true;
                            }
                        });
                    }
                });
                showWarning = isDwellingReplacementCostSelected !== isCoverageFunctionalReplacementCostSelected;
            }
        }
        if (showWarning) {
            addWarningAlert(messages.functionalReplacementCostWarning, 'functionalReplacementCostWarning');
            window.scrollTo(0, 0);
        }
    }, [addWarningAlert, clearBlockAlerts, endorsementVM, getQuoteCoverages, isDwelling, isLandlordHome]);

    const getHOPCovAValue = useCallback(() => {
        let covAChosenTermValue = 0;
        const coverages = getQuoteCoverages();
        coverages.baseCoverages.forEach((basecoverage) => {
            if (basecoverage.code_ML === 'HOPCovA') {
                basecoverage.terms.forEach((hopcovaterm) => {
                    if ((hopcovaterm.codeIdentifier_ML === 'HOPCovALimit')) {
                        const hopCovAChosenTerm = hopcovaterm.chosenTermValue;
                        covAChosenTermValue = parseFloat(hopCovAChosenTerm.replace(/,/g, ''));
                    }
                });
            }
        });
        return covAChosenTermValue;
    }, [getQuoteCoverages]);

    const getITVValidation = useCallback(() => {
        const hopCovAChosenTermValue = getHOPCovAValue();
        let returnValue = false;
        const coverages = getQuoteCoverages();
        _.get(coverages, 'baseCoverages', []).forEach((basecoverage) => {
            if (basecoverage.code_ML === 'HOPCovA') {
                basecoverage.terms.forEach((hopcovaterm) => {
                    if ((hopcovaterm.codeIdentifier_ML === 'HOPCovALimit')) {
                        const hopCovACacluateValue = hopcovaterm.directValue;
                        const replacementCostValue = coverages.replacementCost_ML.amount;
                        const itvpercent = ((hopCovACacluateValue / replacementCostValue) * 100);
                        if (hopCovAChosenTermValue !== hopCovACacluateValue) {
                            if ((itvpercent >= 80) && (itvpercent <= 95)) {
                                returnValue = true;
                            }
                        }
                    }
                });
            }
        });
        return returnValue;
    }, [getHOPCovAValue, getQuoteCoverages]);

    const setHasITVWarning = useCallback(() => {
        let localHasWarning;
        if (isHomeOwners && hoCoveragePartType === 'hopdwelling') {
            localHasWarning = getITVValidation();
        } else {
            localHasWarning = false;
        }
        if (localHasWarning) {
            if(getNumberOfAlerts(ITVERRORMESSAGE) <= 0){
                addWarningAlert(messages.ITVAck, ITVERRORMESSAGE);
            }
        } else if(getNumberOfAlerts(ITVERRORMESSAGE) > 0){
            clearBlockAlerts(ITVERRORMESSAGE);
        }
    }, [addWarningAlert, clearBlockAlerts, getITVValidation, getNumberOfAlerts, hoCoveragePartType, isHomeOwners]);


    const checkisBlockedByUWIssues = useCallback(() => {
        setIsBlockedByUWIssues(MLUWService.isBlockedByUWIssues(uwIssues, MLUWIssuesBlockingPoints.BLOCKS_BIND));
    }, [MLUWIssuesBlockingPoints.BLOCKS_BIND, uwIssues]);

    const isQuoteStale = () => {
        return _.get(endorsementVM, 'value.quoteStatus.isStale', false);
    };

    const refreshQuoteStatus = useCallback((updatedQuoteStatus) => {
        // Clone Deep so dependencies on quoteStatus are firing due to reference being changed
        const copy = viewModelService.clone(endorsementVM);
        copy.value = updatedQuoteStatus;
    }, [endorsementVM, viewModelService]);

    const handleSuccessRequote = useCallback((policyChange) => {
        const newPolicyChange = new PolicyChange(policyChange);
        Object.assign(endorsementVM.value, newPolicyChange);
        endorsementVM.isCoverageChanged_ML.value = false;
        // Update UW issue status
        _.set(endorsementVM, 'uwIssues_ML.value', policyChange.uwIssues_ML);
        _.set(endorsementVM, 'value.quoteStatus.isStale', false);
        refreshQuoteStatus(endorsementVM.value.quoteStatus);
        checkisBlockedByUWIssues();
    }, [checkisBlockedByUWIssues, endorsementVM, refreshQuoteStatus]);

    const markStale = useCallback(() => {
        endorsementVM.value.quoteStatus.isStale = true;
    }, [endorsementVM]);

    const formatValidationErrors = useCallback((errors) => {
        let msg = '';
        if (errors.length > 1) {
            msg = `${translator(messages.addressIssues)}<br></br><br></br>`;
        }
        errors.forEach((error) => {
            msg += `${error}<br></br>`;
        });
        if (isAgent) {
            setDisableContinueForValidationErrors(true);
        }
        const fixMsg = translator(messages.navigateToDiffScreen);
        msg = `${msg}<br></br>${fixMsg}`;

        return {
            id: 'ml.endorsement.common.MLCoveragePage.validationErrors',
            defaultMessage: msg
        };
    }, [isAgent, translator]);

    const onClickHere = useCallback(() => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep('endorsementAdditionalChanges', steps, currentStepIndex, changeNextSteps, goNext, productCode)
    }, [changeNextSteps, currentStepIndex, goNext, productCode, steps]);

    const setThirdPartyWarningAlert = useCallback((validationErrors) => {
        const thirdPartyAlertMsg = translator(messages.thirdPartyAlertMessage);
        const index = _.indexOf(validationErrors, thirdPartyAlertMsg);
        if (index !== -1) {
            validationErrors.splice(index, 1);
            addWarningAlert(thirdPartyAlertMsg, THIRD_PARTY_ALERT_NAME);
        }
    }, [addWarningAlert, translator]);

    const setValidationError = useCallback((errors) => {
        if (!_.isEmpty(errors)) {
            _.uniq(errors).forEach((error, index) => {
                const shouldShowOriginalError = COVERAGE_ERROR_MESSAGES.some(msg =>
                    error.includes(msg)
                );    
                const errormessage = error.split(': ')[1];
                const alertName = `validation-${index}`;

                if (errormessage && !_.isEmpty(errormessage)) {
                    if (errormessage.includes('Coverage Is') || shouldShowOriginalError) {
                        addErrorAlert(error, alertName);
                    } else {
                        addErrorAlert(errormessage, alertName);
                    }

                } else {
                    addErrorAlert(error, alertName);
                }
            });
        }
    }, [addErrorAlert]);

    const setValidationErrorAlerts = useCallback((endorsement) => {
        let hasError = false;
        clearBlockAlerts(VALIDATION_ALERT_NAME);
        clearBlockAlerts(THIRD_PARTY_ALERT_NAME);
        setThirdPartyWarningAlert(endorsement.validationErrors_ML);
        if (!_.isEmpty(endorsement.validationErrors_ML)) {
            setValidationError(endorsement.validationErrors_ML);
            hasError = true;
            endorsement.validationErrors_ML = null;
        } else {
            setDisableContinueForValidationErrors(false);
        }
        return hasError;
    }, [addErrorAlert, clearBlockAlerts, setValidationError, setThirdPartyWarningAlert, onClickHere]);

    const clearPerilAlerts = useCallback(() => {
        clearBlockAlerts('windHail');
        clearBlockAlerts('roofLoss');
        clearBlockAlerts('allOtherPeril');
        clearBlockAlerts('grcAvailable');
    }, [clearBlockAlerts]);

    const setPerilAlerts = useCallback((warnings) => {
        if (!_.isEmpty(warnings)) {
            if (warnings.includes("WindHail")) {
                addWarningAlert(messages.windstormHailDeductibleBumpedWarning, "windHail");
            }

            if (warnings.includes("MinRoofAge")) {
                addWarningAlert(messages.roofLossSettlementBumpedWarning, "roofLoss");
            }

            if (warnings.includes("AllOtherPeril")) {
                addWarningAlert(messages.allOtherPerilBumpedWarning, "allOtherPeril");
            }

            if (warnings.includes("GRCAvailable")) {
                addWarningAlert(messages.grcAvailableBumpedWarning, "grcAvailable");
            }
        }
    }, [addWarningAlert]);

    const checkAutoCoveragesMismatch = useCallback(() => {
        const validationErrors = _.get(endorsementVM, 'validationErrors_ML.value', []);
        _.set(endorsementVM, 'value.quoteStatus.coverageMismatch', false);

        const coverages = getQuoteCoverages();
        let allCovs = coverages.lineCoverages.concat(
            coverages.optionalCoverages_ML
        );
        coverablesToDisplay.forEach((coverable) => {
            allCovs = allCovs.concat(coverable.syncedCoverages);
        });

        allCovs.forEach((coverage) => {
            coverage.terms.forEach((term) => {
                if (term.validationMessage_ML) {
                    _.set(endorsementVM, 'value.quoteStatus.coverageMismatch', true);
                    if (!validationErrors.some((err) => err === term.validationMessage_ML)) {
                        validationErrors.push(term.validationMessage_ML);
                    }
                }
            });
        });
        if (validationErrors && validationErrors.length > 0) {
            _.set(endorsementVM, 'validationErrors_ML.value', validationErrors);
        } else {
            _.set(endorsementVM, 'validationErrors_ML.value', null);
        }
        return setValidationErrorAlerts(endorsementVM.value);
    }, [coverablesToDisplay, endorsementVM, getQuoteCoverages, setValidationErrorAlerts]);

    const parseErrorForMessage = (errorString) => {
        const indexOfMessages = errorString.indexOf('Messages_ML');
        let errorMessages = errorString.substring(indexOfMessages).split(']')[0];
        errorMessages = errorMessages.split('[')[1];
        return errorMessages.split(',')[0];
    };

    const handleFailedRequote = useCallback((error) => {
        const message = translator(messages.invalidQuote);
        const description = translator(messages.invalidOptions);
        console.error('Error updating custom quote', error);
        const code = _.get(error, 'appErrorCode');
        if (code === -31000 && ['806', '807'].includes(error.errorCode)) { // TODO error code
            addErrorAlert(parseErrorForMessage(error.baseError), RATING_ERROR);
        } else {
            showErrorModal(message, description);
        }
    }, [addErrorAlert, showErrorModal, translator]);

    const hasValidationErrors = useCallback(() => {
        return getNumberOfAlerts(VALIDATION_ALERT_NAME) > 0;
    }, [getNumberOfAlerts]);


    const updateCoverages = useCallback((callback,showValidationErrors, shouldUpdate = true, forceFullUpdate = false) => {
        isSuspendLiabilitySelected();

        const coverages = getQuoteCoverages();
        const data = {
            [`${lobPathString}`]: coverages
        };

        if (shouldUpdate) {
            _.set(endorsementVM, 'value.quoteStatus.showLoading', true);
            clearAlerts();
            const structuredClauses = ClausesUtil.structureClausesForServer(
                coverages,
                lobPathString,
                null
            );

            const operation = EndorsementService.updateCoverages(
                jobID,
                (forceFullUpdate || ClausesUtil.isDependentClausesEmpty()) ? data : structuredClauses,
                authHeader
            );

            showProgressDialog(platformMessages.loading, operation, true, 30000);
            operation.then((policyChange) => {
                // PC has a bug that return isCoverageChanged_ML to false when dis-select the SuspendLiability
                // But for other LOBs are fine, so make this condition check to avoid isCoverageChanged_ML is set incorrectly.
                if (isPersonalAuto) {
                    endorsementVM.isCoverageChanged_ML.value = !!wasCoverageChanged;
                    setWasCoverageChanged(false);
                } else {
                    endorsementVM.isCoverageChanged_ML.value = policyChange.isCoverageChanged_ML;
                    if(isModernProduct && isHomeOwners) {
                        endorsementVM.lobData.homeowners.shoudlShowFortifiedWarning.value = policyChange.lobData.homeowners?.shoudlShowFortifiedWarning
                    }
                }

                const updatedCoverages = getPolicyChangeCoverages(policyChange);

                _.set(endorsementVM, `lobData.${lobPathString}.value.offerings[0].coverages`, updatedCoverages);
                setCovsModel(updatedCoverages);

                setHasITVWarning();
                isFortifiedUnselected();
                if(isOOSConflict && isAgent){
                    _.set(endorsementVM, 'isOutOfSequenceConflict_ML.value',true);
                }else if (showValidationErrors && policyChange.validationErrors_ML && policyChange.validationErrors_ML.length > 0) {
                    markStale();
                    endorsementVM.isCoverageChanged_ML.value = true;
                    if (policyChange.validationErrors_ML[0] === "Animal Liability Exclusion must contain at least one schedule item.") {
                        _.set(endorsementVM, 'validationErrors_ML.value', null);
                    } else {
                        _.set(endorsementVM, 'validationErrors_ML.value', policyChange.validationErrors_ML);
                    }
                    window.scrollTo(0, 0);
                } else {
                    endorsementVM.validationErrors_ML.value = null;
                }
                _.set(endorsementVM, 'uwIssues_ML.value', policyChange.uwIssues_ML);
            });
            operation.catch((error) => {
                console.error(error);
                // Unsuccessful quote should give user a chance to requote
                endorsementVM.isCoverageChanged_ML.value = true;
                handleFailedRequote(error);
            });
            operation.finally(()=> {
                _.set(endorsementVM, 'value.quoteStatus.showLoading', false);
                let hasError = false;
                // $scope.form.submitted = false;
                if (isPersonalAuto) {
                    hasError = checkAutoCoveragesMismatch();
                } else {
                    hasError = setValidationErrorAlerts(endorsementVM.value);
                }

                if (!_.get(endorsementVM, 'value.quoteStatus.coverageMismatch') && !hasValidationErrors() && !hasError && !!callback) {
                    callback();
                }
                updateWizardSubmissionData(endorsementVM);
            });
        } else {
                _.set(endorsementVM, `lobData.${lobPathString}.value.offerings[0].coverages`, coverages);
                endorsementVM.isCoverageChanged_ML.value = true;

                setCovsModel(coverages);
                updateWizardSubmissionData(endorsementVM);
        }
    }, [EndorsementService, authHeader, checkAutoCoveragesMismatch, clearAlerts, endorsementVM, getPolicyChangeCoverages, getQuoteCoverages, handleFailedRequote, hasValidationErrors, isHomeOwners, isPersonalAuto, isSuspendLiabilitySelected, jobID, lobPathString, markStale, setHasITVWarning, setValidationErrorAlerts, showProgressDialog, updateWizardSubmissionData, wasCoverageChanged, isFortifiedUnselected]);

    const doQuote = useCallback((callback) => {
        clearBlockAlerts(RATING_ERROR);
        clearPerilAlerts();
        const quotePolicyChangePromise = EndorsementService.quoteEndorsement([endorsementVM.jobID.value], authHeader);
        showProgressDialog(platformMessages.loading, quotePolicyChangePromise, true);
        quotePolicyChangePromise.then((policyChange) => {
            const bumpedPerils = policyChange.perilBumpedCoverages_Ext

            setPerilAlerts(bumpedPerils);

            handleSuccessRequote(policyChange);
            if (callback) {
                callback();
            }
            const updatedCoverages = getPolicyChangeCoverages(policyChange);

            _.set(endorsementVM, `lobData.${lobPathString}.value.offerings[0].coverages`, updatedCoverages);
            setCovsModel(updatedCoverages);
            updateWizardSubmissionData(endorsementVM);
        });

        quotePolicyChangePromise.catch((error) => handleFailedRequote(error));
    }, [EndorsementService, authHeader, clearBlockAlerts, setPerilAlerts, clearPerilAlerts, endorsementVM, getPolicyChangeCoverages, handleFailedRequote, handleSuccessRequote, lobPathString, showProgressDialog, updateWizardSubmissionData]);

    const quote = useCallback((callback)=> {
        if (_.get(endorsementVM, 'value.quoteStatus.isStale') || endorsementVM.isCoverageChanged_ML.value) {
            validatePANamedExclude((isValid) => {
                if (isValid) {
                    updateCoverages(() => {
                        doQuote(callback);
                        isSuspendLiabilitySelected();
                    }, true);
                }
            });
        }
    }, [doQuote, endorsementVM, isSuspendLiabilitySelected, updateCoverages, validatePANamedExclude,isFortifiedUnselected]);

    const isPrevButtonAvailable = useCallback((_prevIndex) => {
        return _prevIndex !== 0;
    }, []);

    const isNextButtonAvailable = useCallback((_nextIndex) => {
        const coverages = getQuoteCoverages();
        return _nextIndex < coverages.vehicleCoverages.length;
    }, [getQuoteCoverages]);

    const initCoverableToDisplay = useCallback((_prevIndex, _nextIndex) => {
        setIsPrevAvailable(isPrevButtonAvailable(_prevIndex));
        setIsNextAvailable(isNextButtonAvailable(_nextIndex));
    }, [isNextButtonAvailable, isPrevButtonAvailable]);

    const getCoverablesToDisplay = useCallback((start, end) => {
        const coverages = getQuoteCoverages();
        return coverages.vehicleCoverages.slice(start, end);
    }, [getQuoteCoverages]);

    const findCoverageInMap = useCallback((coverageCode, map) => {
        return map.find((covInMap) => {
            return covInMap.coverageCode === coverageCode;
        });
    }, []);

    const findTermInMap = useCallback((coverageCode, termCode, map) => {
        const coverage = findCoverageInMap(coverageCode, map);
        let isTermInMap = false;
        if (coverage) {
            isTermInMap = coverage.terms.find((termInMap) => {
                return termInMap.termCode === termCode;
            });
        }
        return isTermInMap;
    }, [findCoverageInMap]);

    const extractTermNames = useCallback((coverage, map) => {
        coverage.terms.forEach((term) => {
            const covTermInMap = findTermInMap(coverage.publicID, term.patternCode, map);
            if (!covTermInMap) {
                if (term.name !== EMPTY_STRING) {
                    const coverageMap = findCoverageInMap(coverage.publicID, map);
                    coverageMap.terms.push({
                        termName: term.name,
                        termCode: term.patternCode,
                        isVisible_ML: term.isVisible_ML,
                        updated: !!term.updated
                    });
                }
            } else {
                covTermInMap.isVisible_ML = covTermInMap.isVisible_ML || term.isVisible_ML;
            }
        });
    }, [findCoverageInMap, findTermInMap]);

    const createEmptyTermObjs = useCallback((numberOfTerms) => {
        const emptyTerms = [];
        const termObj = {
            isVisible_ML: true,
            isEditable_ML: false
        }
        for (let i = 0; numberOfTerms > i; i++) {
            emptyTerms.push(termObj);
        }
        return emptyTerms;
    }, []);

    const addEmptyScheduleItemNames = useCallback((coverage, map) => {
        const excludeNamedDriverCov = coverage.scheduledItems_ML.excludeNamedDrivers;
        if (excludeNamedDriverCov && excludeNamedDriverCov.length > 0) {
            const coverageMap = findCoverageInMap(coverage.publicID, map);
            coverageMap.terms = createEmptyTermObjs(excludeNamedDriverCov.length);
        }
    }, [createEmptyTermObjs, findCoverageInMap]);

    const extractCoverageTermNames = useCallback((coverages, map) => {
        coverages.forEach((coverage) => {
            const covInMap = findCoverageInMap(coverage.publicID, map);
            if (!covInMap) {
                if (!(coverage.name === EMPTY_STRING || coverage.name.indexOf(`- ${EMPTY_STRING}`) > -1)) {
                    map.push({
                        coverageName: coverage.name,
                        coverageCode: coverage.publicID,
                        description: coverage.description,
                        required: coverage.required,
                        selected: coverage.selected,
                        terms: []
                    });
                }
            }

            if (coverage.terms && coverage.terms.length > 0) {
                extractTermNames(coverage, map);
            }
            if (!_.isEmpty(coverage.scheduledItems_ML)) {
                addEmptyScheduleItemNames(coverage, map);
            }
        });
    }, [addEmptyScheduleItemNames, extractTermNames, findCoverageInMap]);

    const sortCoverageTitleMaps = useCallback(() => {
        setVehicleCoverageNamesMap(_.sortBy(vehicleCoverageNamesMap, 'coverageName'));
        setLineCoverageNamesMap(_.sortBy(lineCoverageNamesMap, 'coverageName'));
        setOptionalCoverageNamesMap(_.sortBy(optionalCoverageNamesMap, 'coverageName'));
    }, [lineCoverageNamesMap, optionalCoverageNamesMap, vehicleCoverageNamesMap]);

    const createCoverageTitles = useCallback((localCoverablesToDisplay = coverablesToDisplay, localLineCoverageNamesMap = lineCoverageNamesMap, localVehicleCoverageNamesMap = vehicleCoverageNamesMap, localOptionalCoverageNamesMap = optionalCoverageNamesMap) => {
        const coverages = getQuoteCoverages();
        extractCoverageTermNames(coverages.lineCoverages, localLineCoverageNamesMap);
        localCoverablesToDisplay.forEach((vehicleCov) => {
            extractCoverageTermNames(vehicleCov.coverages, localVehicleCoverageNamesMap);
        });
        extractCoverageTermNames(coverages.optionalCoverages_ML, localOptionalCoverageNamesMap);

        sortCoverageTitleMaps();
    }, [coverablesToDisplay, extractCoverageTermNames, getQuoteCoverages, lineCoverageNamesMap, optionalCoverageNamesMap, sortCoverageTitleMaps, vehicleCoverageNamesMap]);

    const createEmptyCoverageObject = useCallback((displayableCoverage) => {
        const retObj = {};
        retObj.name = `${displayableCoverage.coverageName} - ${EMPTY_STRING}`;
        retObj.publicID = displayableCoverage.coverageCode;
        retObj.coverageCode = displayableCoverage.coverageCode;
        retObj.isEmpty = true;
        retObj.terms = [];
        const termsLength = displayableCoverage.terms.length;
        if (termsLength > 0) {
            retObj.terms = createEmptyTermObjs(termsLength);
        }
        return retObj;
    }, [createEmptyTermObjs]);

    const addEmptyCoverageObject = useCallback((coverages, displayableCoverage, index) => {
        const dummyCoverageObj = createEmptyCoverageObject(displayableCoverage);
        coverages.splice(index, 0, dummyCoverageObj);
    }, [createEmptyCoverageObject]);

    const areCoverageTermsEqual = (availableTerms, termsToCheck) => {
        let isEqual = true;
        // check per term
        availableTerms.forEach((availableTerm) => {
            if (!termsToCheck.find((term) => term.patternCode === availableTerm.termCode)) {
                isEqual = false;
            }
        });
        // check overall
        if (isEqual) {
            isEqual = availableTerms.length === termsToCheck.length;
        }

        return isEqual;
    };

    const createEmptyTermObjsForDifference = useCallback((displayableCoverage, coverage) => {
        displayableCoverage.terms.forEach((displayableTerm, index) => {
            if (!coverage.terms.find((term) => term.patternCode === displayableTerm.termCode)) {
                const dummyTermObj = {
                    name: EMPTY_STRING,
                    patternCode: displayableTerm.termCode,
                    isVisible_ML: true,
                    updated: false
                };
                coverage.terms.splice(index, 0, dummyTermObj);
                coverage.terms.join();
            }
        });
    }, []);

    const processSyncTerms = useCallback((vehicleCoverage, displayableCoverage, syncedCoverages) => {
        if (vehicleCoverage) {
            if (!areCoverageTermsEqual(displayableCoverage.terms, vehicleCoverage.terms) && _.isEmpty(vehicleCoverage.scheduledItems_ML)) {
                createEmptyTermObjsForDifference(displayableCoverage, vehicleCoverage);
            }
            syncedCoverages.push(vehicleCoverage);
        }
    }, [createEmptyTermObjsForDifference]);

    const createEmptyTermObjsForScheduleItem = useCallback((coverage, numberOfTerms) => {
        coverage.terms = [];
        for (let i = 0; numberOfTerms > i; i++) {
            const dummyTermObj = {
                name: EMPTY_STRING,
                isVisible_ML: true,
                updated: false
            };
            coverage.terms.push(dummyTermObj);
        }
    },  []);

    const syncScheduleItemTerms = useCallback((currentVehicle) => {
        const curExcludeNamedDriversCov = currentVehicle.syncedCoverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
        if (curExcludeNamedDriversCov && _.isEmpty(curExcludeNamedDriversCov.scheduledItems_ML.excludeNamedDrivers)) {
            // search vehicles that have PAExcludeNamedDriverVehicleLevel_ML which has excluded driverse
            const otherVehicles = coverablesToDisplay.filter((veh) => veh.fixedId !== currentVehicle.fixedId);
            const otherVehHaveScheduleItem = otherVehicles.find((veh) => {
                const excludeNamedDriverCov = veh.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
                let hasScheduledItem = false;
                if (excludeNamedDriverCov) {
                    const excludedDrivers = excludeNamedDriverCov.scheduledItems_ML.excludeNamedDrivers;
                    hasScheduledItem = !_.isEmpty(excludedDrivers);
                }
                return hasScheduledItem;
            });

            // add empty terms to coverage for missing schedule items
            if (otherVehHaveScheduleItem) {
                const excludeNamedDriverCov = otherVehHaveScheduleItem.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
                const numberOfDrivers = excludeNamedDriverCov.scheduledItems_ML.excludeNamedDrivers.length;
                createEmptyTermObjsForScheduleItem(curExcludeNamedDriversCov, numberOfDrivers);
            }
        }
    }, [coverablesToDisplay, createEmptyTermObjsForScheduleItem]);

    const processSyncCoverages = useCallback((vehicle, localVehicleCoverageNamesMap) => {
        localVehicleCoverageNamesMap.forEach((displayableCoverage, index) => {
            const vehicleCoverage = vehicle.coverages.find((coverage) => coverage.publicID === displayableCoverage.coverageCode);
            if (!vehicleCoverage) {
                addEmptyCoverageObject(vehicle.syncedCoverages, displayableCoverage, index);
            } else {
                processSyncTerms(vehicleCoverage, displayableCoverage, vehicle.syncedCoverages);
            }
        });
        syncScheduleItemTerms(vehicle);
    }, [addEmptyCoverageObject, processSyncTerms, syncScheduleItemTerms]);

    const sortCoverableCoverages = useCallback(() => {
        const coverages = getQuoteCoverages();
        const sortedLineCoverages = _.sortBy(coverages.lineCoverages, 'name');
        const sortedOptionalCoverages = _.sortBy(coverages.optionalCoverages_ML, 'name');
        coverages.lineCoverages = sortedLineCoverages;
        coverages.optionalCoverages_ML = sortedOptionalCoverages;
        coverages.vehicleCoverages.forEach((vehicle) => {
            const sortedVehicleCoverages = _.sortBy(vehicle.coverages, 'name');
            vehicle.coverages = sortedVehicleCoverages;
            let sortedCoverageTerms = [];
            vehicle.coverages.forEach((coverage) => {
                sortedCoverageTerms = _.sortBy(coverage.terms, 'patternCode');
            });
            vehicle.coverages.terms = sortedCoverageTerms;
        });
    }, [getQuoteCoverages]);

    const createCoverableCoverageMap = useCallback((localCoverablesToDisplay = coverablesToDisplay, localVehicleCoverageNamesMap = vehicleCoverageNamesMap) => {
        sortCoverableCoverages();
        localCoverablesToDisplay.forEach((vehicle) => {
            vehicle.syncedCoverages = [];
            processSyncCoverages(vehicle, localVehicleCoverageNamesMap);
        });
    }, [coverablesToDisplay, processSyncCoverages, sortCoverableCoverages, vehicleCoverageNamesMap]);

    const updateMaps = (_prevIndex, _nextIndex) => {
        // resetMaps
        const localPrevIndex = _.isUndefined(_prevIndex) ? prevIndex : _prevIndex;
        const localNextIndex = _.isUndefined(_nextIndex) ? nextIndex : _nextIndex;
        lineCoverageNamesMap.splice(0, lineCoverageNamesMap.length);
        vehicleCoverageNamesMap.splice(0, vehicleCoverageNamesMap.length);
        optionalCoverageNamesMap.splice(0, optionalCoverageNamesMap.length);
        const localCoverablesToDisplay = getCoverablesToDisplay(localPrevIndex, localNextIndex);

        setCoverablesToDisplay(localCoverablesToDisplay);
        initCoverableToDisplay(localPrevIndex, localNextIndex);
        createCoverageTitles(localCoverablesToDisplay, lineCoverageNamesMap, vehicleCoverageNamesMap, optionalCoverageNamesMap);
        createCoverableCoverageMap(localCoverablesToDisplay, vehicleCoverageNamesMap);

        setLineCoverageNamesMap(_.sortBy(lineCoverageNamesMap, 'coverageName'));
        setVehicleCoverageNamesMap(_.sortBy(vehicleCoverageNamesMap, 'coverageName'));
        setOptionalCoverageNamesMap(_.sortBy(optionalCoverageNamesMap, 'coverageName'));
    };

    const setTermMonthsFunc = () => {
        setTermType_ML('Annual');
        setTermMonths(DEFAULT_TERM_MONTHS);
        const termType = _.get(endorsementVM, 'baseData.termType_ML.value') ? endorsementVM.baseData.termType_ML : endorsementVM.baseData.termType;
        if (termType && termType.value && termType.value.code === 'HalfYear') {
            setTermMonths(HALF_TERM_MONTHS);
            setTermType_ML('HalfYear');
        }
    };

    const stickyBarInfo = () => {
        const initQuoteStatus = {
            isStale: false,
            showLoading: false
        };
        _.set(endorsementVM, 'value.quoteStatus', initQuoteStatus);
        _.set(endorsementVM, 'value.termMonths', termMonths);
        const paymentDetails = _.get(endorsementVM, 'value.paymentDetails_ML');
        endorsementVM.value.selectedPaymentPlan = paymentDetails.paymentPlans_ML.find((plan) => {
            return plan.billingId === paymentDetails.selectedPaymentPlan;
        });
    };

    const initPAMethods = () => {
        const maxNumberOfVehicles = 3;
        setMaxNumberOfVehicleShown(maxNumberOfVehicles);
        setPrevIndex(0);
        const coverages = getQuoteCoverages();
        const _nextIndex = coverages.vehicleCoverages.length > 3 ? 3 : coverages.vehicleCoverages.length;
        setNextIndex(_nextIndex);
        setIsPrevAvailable(false);
        setIsNextAvailable(false);
        setLineCoverageNamesMap([]);
        setVehicleCoverageNamesMap([]);
        setOptionalCoverageNamesMap([]);
        setCoverablesToDisplay([]);
        updateMaps(0, _nextIndex);
        setTermMonthsFunc();
    };

    const isAccidentPreventionSelected = useCallback(() => {
        let accidentPreventionSelected = false;
        if (ratedDrivers) {
            ratedDrivers.forEach((driver) => {
                if (driver.driverModifiers_ML.modifiers) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (accidentPreventionCodes.indexOf(modifier.codeIdentifier_ML) > -1) {
                            if (modifier.chosenTermValue) {
                                accidentPreventionSelected = true;
                            }
                        }
                    });
                }
            });
        }
        return accidentPreventionSelected;
    }, [ratedDrivers]);

    const hasAccidentPreventionWithoutPrimaryVehicle = useCallback((driver) => {
        let needsAssignment = false;
        if (driver.driverModifiers_ML.modifiers) {
            driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                if (accidentPreventionCodes.indexOf(modifier.codeIdentifier_ML) > -1) {
                    if (modifier.chosenTermValue) {
                        needsAssignment = !driver.driverModifiers_ML.primaryVehicleFixedId;
                    }
                }
            });
        }
        return needsAssignment;
    }, []);

    const hasDefensiveDriverWithoutPrimaryVehicle = useCallback((driver) => {
        let needsAssignment = false;
        if (driver.driverModifiers_ML.modifiers) {
            driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                if (defensiveDriverCodes.indexOf(modifier.codeIdentifier_ML) > -1) {
                    if (modifier.chosenTermValue) {
                        needsAssignment = !driver.driverModifiers_ML.primaryVehicleFixedId;
                    }
                }
            });
        }
        return needsAssignment;
    }, []);

    const isNJAutoPolicy = useCallback(() => {
        const hasPa = !!paModel;
        const polState = _.get(endorsementVM, 'baseData.policyAddress.state.value.code');
        return hasPa && polState === 'NJ';
    }, [endorsementVM, paModel]);

    const hasOneDriverMultipleVehicles = useCallback(() => {
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        const hasMultipleVehicles = eligibleVehicles.length > 1;
        const hasOneRatedDriver = ratedDrivers.length === 1;
        return hasOneRatedDriver && hasMultipleVehicles;
    }, [isVehicleEligibleForAccidentPrevention, ratedDrivers, vehicles]);

    const hasPrimaryVehicleAssigned = useCallback(() => {
        return ratedDrivers.length > 0 && !!ratedDrivers[0].driverModifiers_ML.primaryVehicleFixedId;
    }, [ratedDrivers]);

    const isDriverPrimaryVehicleNeeded = useCallback(() => {
        // check to see if there are any drivers with accident prevention selected but no primary vehicle selected
        let primaryVehicleDefaultingRequired = false;
        if (isNJAutoPolicy()) {
            if (hasOneDriverMultipleVehicles() && !hasPrimaryVehicleAssigned()) {
                primaryVehicleDefaultingRequired = true;
            } else {
                ratedDrivers.forEach((driver) => {
                    if (hasDefensiveDriverWithoutPrimaryVehicle(driver)) {
                        primaryVehicleDefaultingRequired = true;
                    }
                });
            }
        } else if (endorsementVM.baseData.isDriverPrimaryVehicleRequiredState_Ext.value) {
            if (isAccidentPreventionSelected()) {
                ratedDrivers.forEach((driver) => {
                    if (hasAccidentPreventionWithoutPrimaryVehicle(driver)) {
                        primaryVehicleDefaultingRequired = true;
                    }
                });
            }
        }
        return primaryVehicleDefaultingRequired;
    }, [endorsementVM.baseData.isDriverPrimaryVehicleRequiredState_Ext.value, hasAccidentPreventionWithoutPrimaryVehicle, isAccidentPreventionSelected, ratedDrivers]);

    const defaultDriverPrimaryVehicles = useCallback(() => {
        setPrimaryVehiclesDefaulted(true);
        let vehicleIndex = 0;
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        ratedDrivers.forEach((driver) => {
            if (hasAccidentPreventionWithoutPrimaryVehicle(driver) || hasDefensiveDriverWithoutPrimaryVehicle(driver)) {
                driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                    if ((accidentPreventionCodes.indexOf(modifier.codeIdentifier_ML) > -1 || (isNJAutoPolicy() && defensiveDriverCodes.indexOf(modifier.codeIdentifier_ML) > -1))
                        && !driver.driverModifiers_ML.primaryVehicleFixedId) {
                        driver.driverModifiers_ML.primaryVehicleFixedId = eligibleVehicles[vehicleIndex].fixedId;
                        defaultedDriverPrimaryVehicles.push(driver.fixedId);
                    }
                });
                if (vehicleIndex < eligibleVehicles.length - 1) {
                    vehicleIndex += 1;
                } else {
                    vehicleIndex = 0;
                }
            }
        });
    }, [defaultedDriverPrimaryVehicles, hasAccidentPreventionWithoutPrimaryVehicle, isVehicleEligibleForAccidentPrevention, ratedDrivers, vehicles]);

    const areVehiclePrimaryDriverAssignmentsInvalid = useCallback(() => {
        let areAssignmentsInvalid = false;
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        if (eligibleVehicles.length > 0) {
            eligibleVehicles.forEach((vehicle) => {
                const vehDrivers = vehicleDrivers.filter((vd) => vehicle.fixedId === vd.vehicleID.value);
                if (vehDrivers.length !== 1) {
                    areAssignmentsInvalid = true;
                } else if (vehDrivers[0].percentageDriven_Ext.value !== 100) {
                    areAssignmentsInvalid = true;
                }
            });
        }
        return areAssignmentsInvalid;
    }, [isVehicleEligibleForAccidentPrevention, vehicleDrivers, vehicles]);

    const areVehiclePrimaryDriverAssignmentPercentagesInvalid = useCallback(() => {
        let areAssignmentsInvalid = false;
        const primaryDriverList = [];
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        const ratedDriversNonStudent = getRatedDriversNonStudent(ratedDrivers);
        if (eligibleVehicles.length > 0) {
            if (!validateVehiclesHaveAssignmentsForEveryDriver(eligibleVehicles, ratedDrivers, vehicleDrivers)) {
                areAssignmentsInvalid = true;
            }

            if (!validateVehicleAssignmentPercentages(eligibleVehicles, vehicleDrivers)) {
                areAssignmentsInvalid = true;
            }

            // capture primary drivers for all eligible vehicles
            eligibleVehicles.forEach((vehicle) => {
                const vehicleAssignments = vehicleDrivers.filter((a) => a.vehicleID.value === vehicle.fixedId);
                if (vehicleAssignments.length > 0) {
                    const max = Number(Math.max(...vehicleAssignments.map((ar) => ar.percentageDriven_Ext.value)));
                    primaryDriverList.push(vehicleAssignments.find((t) => parseInt(t.percentageDriven_Ext.value) === max).driverID.value);
                }
            });

            if (ratedDriversNonStudent.length >= eligibleVehicles.length) {
                // check that driver isn't primary on more than one vehicle
                if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                    areAssignmentsInvalid = true;
                }
            } else {
                // check that each rated driver is primary on at least one vehicle
                ratedDriversNonStudent.forEach((driver) => {
                    if (!primaryDriverList.includes(driver.fixedId)) {
                        areAssignmentsInvalid = true;
                    }
                });
            }
        } else if (vehicleDrivers.length > 0) {
            areAssignmentsInvalid = true;
        }
        return areAssignmentsInvalid;
    }, [getRatedDriversNonStudent, isVehicleEligibleForAccidentPrevention, ratedDrivers, validateVehicleAssignmentPercentages, validateVehiclesHaveAssignmentsForEveryDriver, vehicleDrivers, vehicles]);

    const isVehiclePrimaryDriverDefaultingNeeded = useCallback(() => {
        let primaryDriverDefaultingRequired = false;
        if (_.get(endorsementVM, 'baseData.isVehiclePrimaryDriverState_Ext.value')) {
            if (isAccidentPreventionSelected(ratedDrivers)) {
                if (areVehiclePrimaryDriverAssignmentsInvalid()) {
                    primaryDriverDefaultingRequired = true;
                }
            }
        } else if (_.get(endorsementVM, 'baseData.isVehiclePrimaryDriverPercentageState_Ext.value')) {
            if (isAccidentPreventionSelected(ratedDrivers)) {
                if (areVehiclePrimaryDriverAssignmentPercentagesInvalid()) {
                    primaryDriverDefaultingRequired = true;
                }
            }
        }
        return primaryDriverDefaultingRequired;
    }, [areVehiclePrimaryDriverAssignmentPercentagesInvalid, areVehiclePrimaryDriverAssignmentsInvalid, endorsementVM, isAccidentPreventionSelected, ratedDrivers]);

    const defaultVehiclePrimaryDrivers = useCallback(() => {
        if (_.get(endorsementVM, 'baseData.isVehiclePrimaryDriverState_Ext.value')) {
            setPrimaryDriversDefaulted(true);
            let driverIndex = 0;
            const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
            vehicleDrivers.value = [];
            eligibleVehicles.forEach((veh) => {
                const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
                vehicleDriver.vehicleID.value = veh.fixedId;
                if (driverIndex >= ratedDrivers.length) {
                    driverIndex = 0;
                }
                vehicleDriver.driverID.value = ratedDrivers[driverIndex].fixedId;
                vehicleDriver.percentageDriven_Ext.value = 100;
                vehicleDrivers.pushElement(vehicleDriver.value);
                driverIndex++;
            });
        } else if (_.get(endorsementVM, 'baseData.isVehiclePrimaryDriverPercentageState_Ext.value')) {
            setPrimaryDriversDefaulted(true);
            let driverIndex = 0;
            const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
            vehicleDrivers.value = [];
            eligibleVehicles.forEach((veh) => {
                const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
                vehicleDriver.vehicleID.value = veh.fixedId;
                if (driverIndex >= ratedDrivers.length) {
                    driverIndex = 0;
                }
                vehicleDriver.driverID.value = ratedDrivers[driverIndex].fixedId;
                vehicleDriver.percentageDriven_Ext.value = 100;
                vehicleDrivers.pushElement(vehicleDriver.value);

                ratedDrivers.forEach((drv) => {
                    if (drv.fixedId !== vehicleDriver.driverID.value) {
                        const zeroVehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
                        zeroVehicleDriver.vehicleID.value = veh.fixedId;
                        zeroVehicleDriver.driverID.value = drv.fixedId;
                        zeroVehicleDriver.percentageDriven_Ext.value = 0;
                        vehicleDrivers.pushElement(zeroVehicleDriver.value);
                    }
                });
                driverIndex++;
            });
        }
    }, [endorsementVM, isVehicleEligibleForAccidentPrevention, ratedDrivers, vehicleDrivers, vehicles, viewModelService]);

    const updatePrimaryVehicleDrivenIfNeeded = useCallback( async () => {
        let updateNeeded = false;
        if (isDriverPrimaryVehicleNeeded()) {
            defaultDriverPrimaryVehicles();
            updateNeeded = true;
        }
        if (isVehiclePrimaryDriverDefaultingNeeded()) {
            defaultVehiclePrimaryDrivers();
            updateNeeded = true;
        }
        if (updateNeeded) {
            showProgressDialog(messages.savingPolicyChange);
            try {
                await EndorsementService.updateModifiers([ _.cloneDeep(endorsementVM.value)], authHeader);
            } finally {
                hideProgressDialog(messages.savingPolicyChange);
            }
        }
    }, [EndorsementService, authHeader, defaultDriverPrimaryVehicles, defaultVehiclePrimaryDrivers, endorsementVM.value, hideProgressDialog, isDriverPrimaryVehicleNeeded, isVehiclePrimaryDriverDefaultingNeeded, showProgressDialog]);

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Coverages Screen'}, endorsementVM, authHeader)
    }, [])
    
    useEffect(() => {
        MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.updatedCoverages), false, currentStep.mlStepName, authHeader);

        checkisBlockedByUWIssues();
        setTermMonthsFunc();
        stickyBarInfo();
        isSuspendLiabilitySelected();
        if (isPersonalAuto) {
            initPAMethods();
            updatePrimaryVehicleDrivenIfNeeded().then(() => {
                if (MLPolicyChangeDataHolderService.getPageAction() && MLPolicyChangeDataHolderService.getPageAction() === 'requote') {
                    quote();
                    MLPolicyChangeDataHolderService.setPageAction('');
                }
            });
        } else {
            if (MLPolicyChangeDataHolderService.getPageAction() && MLPolicyChangeDataHolderService.getPageAction() === 'requote') {
                quote();
                MLPolicyChangeDataHolderService.setPageAction('');
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onPrevButtonClick = useCallback(() => {
        const newPrevIndex = prevIndex - 1;
        const newNextIndex = nextIndex - 1;
        setIsPrevAvailable(isPrevButtonAvailable(newPrevIndex));
        setIsNextAvailable(isNextButtonAvailable(newNextIndex));

        const newCoverablesToDisplay = getCoverablesToDisplay(newPrevIndex, newNextIndex)
        setCoverablesToDisplay(newCoverablesToDisplay);
        setPrevIndex(newPrevIndex);
        setNextIndex(newNextIndex);
        createCoverageTitles();
        createCoverableCoverageMap(newCoverablesToDisplay);
    }, [createCoverableCoverageMap, createCoverageTitles, getCoverablesToDisplay, isNextButtonAvailable, isPrevButtonAvailable, nextIndex, prevIndex]);

    const onNextButtonClick = useCallback(() => {
        const newPrevIndex = prevIndex + 1;
        const newNextIndex = nextIndex + 1;
        setPrevIndex(newPrevIndex);
        setNextIndex(newNextIndex);
        setIsPrevAvailable(isPrevButtonAvailable(newPrevIndex));
        setIsNextAvailable(isNextButtonAvailable(newNextIndex));

        const newCoverablesToDisplay = getCoverablesToDisplay(newPrevIndex, newNextIndex)
        setCoverablesToDisplay(newCoverablesToDisplay);
        createCoverageTitles();
        createCoverableCoverageMap(newCoverablesToDisplay);
    }, [createCoverableCoverageMap, createCoverageTitles, getCoverablesToDisplay, isNextButtonAvailable, isPrevButtonAvailable, nextIndex, prevIndex]);

    const approvedAllBlockingUWIssuesCallback = useCallback(() => {
        checkisBlockedByUWIssues()
    }, [checkisBlockedByUWIssues]);

    const navigateToStep = useCallback((pathToFind, data = {}) => {
        const indexOfStep = _.findIndex(
            steps,
            ({ path }) => path === pathToFind
        );
        if (!_.isEmpty(data)) {
            _.set(endorsementVM, 'value.wizardActionDataML', data);
        }
        jumpTo(indexOfStep, data);
    }, [endorsementVM, jumpTo, steps]);

    const isQuotingInProgress = useCallback(() => {
        return _.get(endorsementVM, 'value.quoteStatus.showLoading', false);
    }, [endorsementVM]);

    const isButtonDisabledForPAPolicyChange = useCallback(() => {
        return isQuotingInProgress()
            || hasValidationErrors()
            || isOOSConflict
            || (_.get(endorsementVM, 'value.quoteStatus.coverageMismatch', false) === true);
    }, [endorsementVM, hasValidationErrors, isQuotingInProgress]);

    const isButtonDisabledForPolicyChange = useCallback(() => {
        return  isOOSConflict || isQuotingInProgress() || hasValidationErrors();
    }, [hasValidationErrors, isQuotingInProgress]);

    const restoreVehicleDriverValues = useCallback(() => {
        if (primaryDriversDefaulted) {
            const vehicleDriversValueOnLoad = [...vehicleDrivers.value];
            vehicleDrivers.value = vehicleDriversValueOnLoad;
            setVehicleDriversRestored(true);
        }
    }, [primaryDriversDefaulted, vehicleDrivers]);

    const restoreDriverPrimaryVehicles = useCallback(() => {
        if (primaryVehiclesDefaulted) {
            defaultedDriverPrimaryVehicles.forEach((driverId) => {
                const driver = paDrivers.find((drv) => drv.fixedId === driverId);
                driver.driverModifiers_ML.primaryVehicleFixedId = 0;
            });
            setPrimaryVehiclesRestored(true);
        }
    }, [defaultedDriverPrimaryVehicles, paDrivers, primaryVehiclesDefaulted]);

    const completeCurrentStepAndGoNext = useCallback(() => {
        const nextStepID = 'endorsementAdditionalChanges';
        endorsementVM.value.portalCurrentStep_ML = nextStepID;
        MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);
        const lbl = MLEndorsementUtil.stepLabel(currentStep);
        MLEndorsementUtil.setEndorsementDescription(lbl, endorsementVM, translator);
        MLTagManagerService.sendFormStepPolicyChangeStep();
        restoreVehicleDriverValues();
        restoreDriverPrimaryVehicles();

        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(nextStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode);

    }, [EndorsementService, authHeader, changeNextSteps, currentStep, currentStepIndex, endorsementVM, goNext, productCode, restoreDriverPrimaryVehicles, restoreVehicleDriverValues, showProgressDialog, steps, translator, updateWizardData, wizardData]);

    const onNext = useCallback(() => {
        if (endorsementVM.value.isOutOfSequenceConflict_ML) {
            return;
        }

        validatePANamedExclude((isValid) => {
            if (isValid) {
                if ( _.get(endorsementVM, 'value.quoteStatus.isStale', false) || endorsementVM.isCoverageChanged_ML.value) {
                    updateCoverages(() => {
                        quote(completeCurrentStepAndGoNext);
                    }, true);
                } else {
                    completeCurrentStepAndGoNext();

                    if (isGPA) {
                        PolChangeTrackEvent('Endorsement Step Submitted', false, endorsementVM, authHeader, {
                            step: 'PolChange Coverage Screen',
                            action: 'Coverage Submitted'
                        });
                    }
                }
         } else {
                window.scrollTo(0, 0);
            }
        });
    }, [completeCurrentStepAndGoNext, endorsementVM, updateCoverages, validatePANamedExclude, isGPA, authHeader, quote]);

    const getNameForPolicyChangeButton = useCallback(() => {
        if (_.get(endorsementVM, 'value.quoteStatus.isStale', false) && !_.get(endorsementVM, 'isReadOnlyML.value')) {
            return translator(messages.requote);
        }
        return translator(messages.continue)
    }, [endorsementVM, translator]);

    const policyChangeButtonFunction = useCallback(() => {
        if (_.get(endorsementVM, 'value.quoteStatus.isStale', false) && !_.get(endorsementVM, 'isReadOnlyML.value')) {
            quote();
        } else {
            onNext();
        }
    }, [endorsementVM, onNext, quote]);

    const validateInputFields = useCallback(()=> {
        if (!endorsementVM.aspects.valid || !endorsementVM.aspects.subtreeValid) {
            return false;
        }

        return true;
    }, [endorsementVM.aspects.subtreeValid, endorsementVM.aspects.valid]);

    const hasDependentCoverages = (covCode) => {
        const dependencyList = ClausesUtil.getDependentClauseList();

        if (excludedCoveragesWithDependencies.includes(covCode) || !covCode) {
            return true;
        }

        return dependencyList && dependencyList.some((elt) => {
            return elt.name === covCode;
        })
    };

    const syncCoverage = useCallback((callback, covCode, hasTerms, shouldRefresh = false)=> {
        markStale();
        if (!validateInputFields()) {
            return;
        }

        const shouldUpdate = covPagePerfFixEnabled ? shouldRefresh : ClausesUtil.isDependentClausesEmpty() || hasTerms || hasDependentCoverages(covCode);
        const forceFullUpdate = !covCode; // if no covCode is passed in, we need to do a full update

        updateCoverages(callback,false, shouldUpdate, forceFullUpdate);
        isFortifiedUnselected();
    }, [markStale, updateCoverages, validateInputFields]);

    const getMLSettings = useCallback(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response)=> {
            if (response && response.covPagePerfFixEnabled) {
                setCovPagePerfFixEnabled(true);
            }
        });
    }, [authHeader]);

    useEffect(() => {
        getMLSettings();
    }, []);

    const formatAmountString = useCallback((amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');

        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const overrideProps = {
        mlOosConflict: {
            isOOSConflict,
            isAgent
        },
        mlUWIssuesPanel: {
            uwIssues: uwIssues,
            jobID: jobID,
            rejectedIssuesAreQuoteBlocking: true,
            approvedAllBlockingUWIssuesCallback,
        },
        autoStickyHeader: {
            visible: isPersonalAuto,
            selectedQuote: _.get(endorsementVM, 'value', {}),
            coverablesToDisplay,
            prevIndex,
            nextIndex,
            isPrevAvailable,
            isNextAvailable,
            onPrevButtonClick,
            onNextButtonClick,
            navigateToStep,
            submissionVM: endorsementVM,
            forPostQuote: false,
            policyChangeButtonFunction,
            isButtonDisabledForPolicyChange: isButtonDisabledForPAPolicyChange,
            getNameForPolicyChangeButton,
            getPerTermLabel,
            getQuoteCoverages,
            isPolicyChange: true
        },
        commonStickyHeader: {
            visible: !isPersonalAuto,
            selectedQuote: _.get(endorsementVM, 'value', {}),
            getNameForMainButton: getNameForPolicyChangeButton,
            mainButtonFunction: policyChangeButtonFunction,
            getPerTermLabel,
            isPolicyChange: true,
            hasValidationErrors,
            getQuoteCoverages,
            isMainButtonDisabled: isButtonDisabledForPolicyChange
        },
        paEditCoveragesAgent: {
            visible: !_.isUndefined(paModel),
            coverages: covsModel,
            loading: _.get(endorsementVM, 'value.quoteStatus.showLoading', false),
            isDisplayOnly: false,
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            quoteStatus: _.get(endorsementVM, 'value.quoteStatus', {}),
            termMonths,
            isPolicyChange: true,
            hasNamedNonOwner,
            prevIndex,
            nextIndex,
            isPrevAvailable,
            isNextAvailable,
            lineCoverageNamesMap,
            vehicleCoverageNamesMap,
            optionalCoverageNamesMap,
            coverablesToDisplay,
            updateMaps,
            onPrevButtonClick,
            onNextButtonClick,
            totalFees: _.get(endorsementVM, 'value.totalFullTermChargesRPT_Ext'),
            itemizedFees: _.get(endorsementVM, 'value.fullTermFeesCosts_Ext'),
            navigateToStep,
            isModernProduct: _.get(endorsementVM, "isModernProduct_Ext.value", false),
            submissionVM:endorsementVM
            
        },
        homeownersCoverages: {
            visible:  !_.isUndefined(_.get(endorsementVM, 'lobData.homeowners.value'))
        },
        hoEditCoveragesComponent: {
            visible: !_.isUndefined(_.get(endorsementVM, 'lobData.homeowners.value')),
            loading: _.get(endorsementVM, 'value.quoteStatus.showLoading', false),
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isAgent,
            isQuoteStale,
            isEndorsement: true,
            model: covsModel,
            totalFees: _.get(endorsementVM, 'value.totalFullTermChargesRPT_Ext'),
            itemizedFees: _.get(endorsementVM, 'value.fullTermFeesCosts_Ext'),
            isOccupancySecondaryOrSeasonal,
            isModernProduct: _.get(endorsementVM, "isModernProduct_Ext.value", false),
            isNotDwellingPolicy,
            isLLPolicy,
            endorsementVM
        },
        pupCoverages: {
            visible: !_.isUndefined(_.get(endorsementVM, 'lobData.personalUmbrella.value'))
        },
        pupEditCoveragesComponent: {
            model: covsModel,
            loading: _.get(endorsementVM, 'value.quoteStatus.showLoading', false),
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isDisplayOnly: false,
            totalFees: _.get(endorsementVM, 'value.totalFullTermChargesRPT_Ext'),
            itemizedFees: _.get(endorsementVM, 'value.fullTermFeesCosts_Ext'),
            isQuoteStale
        },
        coverageTotalRowLabel: {
            content: translator(messages.coverageTotal)
        },
        coverageValue: {
            className: _.get(endorsementVM, 'value.quoteStatus.isStale', false) ? 'premium coverageValue' : 'coverageValue',
            content: `${formatAmountString(_.get(endorsementVM, 'fullTermCost_Ext.value'))}/${getPerTermLabel(termType_ML)}`
        },
        nextButton: {
            disabled:  _.get(endorsementVM, 'value.quoteStatus.isStale', false) || endorsementVM.isCoverageChanged_ML.value || endorsementVM.isOutOfSequenceConflict_ML.value || isBlockedByUWIssues || (isAgent && disableContinueForValidationErrors)
        },
        nextDescription: {
            content: (
                <FormattedMessage
                    {...messages.nextDesc}
                    values={{
                        additionalChangesNeeded: (
                            <strong>{translator(messages.additionalChangesNeeded)}</strong>
                        )
                    }}
                />
            )
        },
        coveragesTotalContainer: {
            visible: !hasNamedNonOwner
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        },
        resolveComponentMap: {
            mlOutOfSequenceConflictComponent: MLOutOfSequenceConflictComponent,
            mlUWIssuesPanelComponent: MLUWIssuesPanelComponent,
            mlpupeditcoveragescomponent: MLPUPEditCoveragesComponent,
            mlhoeditcoveragescomponent: MLHOEditCoveragesComponent,
            mlpaagenteditcoveragescomponent: MLPAAgentEditCoveragesComponent,
            mlagentquotestickyautocomponent: MLAgentQuoteStickyAutoComponent,
            mlagentquotestickycomponent: MLAgentQuoteStickyComponent
        }
    };

    return (
        <WizardPage
            policyChangePageHeaderML={messages.makeChangesHeader}
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={endorsementVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

MLCoveragesPage.propTypes = wizardProps;
export default MLCoveragesPage;